// API Configuration
export const API_CONFIG = {
  baseURL: 'http://127.0.0.1:8001',
  timeout: 240000, // 4 minutos
};

export const STORAGE_KEYS = {
  token: 'prainte_token',
  user: 'prainte_user',
  theme: 'prainte_theme',
};

// Reasoning Levels
export const REASONING_LEVELS = {
  low: '🚀 Rápido (Econômico)',
  default: '⚖️ Padrão (Recomendado)',
  high: '🏆 Avançado (Consome Créditos)',
};

// Tipo para os níveis de raciocínio
export type ReasoningLevelKey = keyof typeof REASONING_LEVELS;

// Status Colors
export const STATUS_COLORS: Record<string, string> = {
  archived: '#6c757d',
  submitted: '#28a745',
  'in_progress': '#007bff',
  active: '#007bff',
};

// File Upload
export const MAX_FILE_SIZE_MB = 25;
export const ACCEPTED_FILE_TYPES = ['pdf', 'docx', 'txt', 'xlsx', 'csv'];

// Project Types — reaproveita o catálogo curado de Especialistas (fonte única, ver specialistCatalog.ts)
import { SPECIALIST_CATALOG } from './specialistCatalog';
export const PROJECT_TYPES = SPECIALIST_CATALOG.map(s => s.value);

// Section Rules
export const SECTION_RULES: Record<string, {
  required: string[];
  optional: string[];
  word_limits: Record<string, number>;
}> = {
  'Edital Nacional': {
    required: [
      'Resumo',
      'Introdução',
      'Objetivos',
      'Metodologia',
      'Cronograma',
      'Orçamento',
      'Equipe',
    ],
    optional: [
      'Fundamentação Teórica',
      'Resultados Esperados',
      'Referências',
      'Anexos',
    ],
    word_limits: {
      'Resumo': 500,
      'Introdução': 1000,
      'Objetivos': 800,
      'Metodologia': 2000,
    },
  },
  'Edital Estadual': {
    required: [
      'Resumo',
      'Justificativa',
      'Objetivos',
      'Metodologia',
      'Cronograma',
      'Orçamento',
    ],
    optional: [
      'Resultados Esperados',
      'Equipe',
      'Referências',
    ],
    word_limits: {
      'Resumo': 300,
      'Justificativa': 800,
      'Objetivos': 600,
    },
  },
  'Projeto Interno': {
    required: [
      'Resumo Executivo',
      'Escopo',
      'Objetivos',
      'Entregáveis',
    ],
    optional: [
      'Cronograma',
      'Recursos Necessários',
      'Riscos',
    ],
    word_limits: {
      'Resumo Executivo': 400,
      'Escopo': 1000,
    },
  },
  'Outro': {
    required: ['Resumo', 'Objetivos'],
    optional: ['Metodologia', 'Cronograma'],
    word_limits: {},
  },
};

// Available Sections
export const AVAILABLE_SECTIONS = [
  'Resumo',
  'Introdução',
  'Fundamentação Teórica',
  'Justificativa',
  'Objetivos',
  'Objetivos Gerais',
  'Objetivos Específicos',
  'Metodologia',
  'Cronograma',
  'Orçamento',
  'Equipe',
  'Resultados Esperados',
  'Impactos',
  'Referências',
  'Anexos',
  'Escopo',
  'Entregáveis',
  'Recursos Necessários',
  'Riscos',
  'Resumo Executivo',
];

// Formatting Actions
export const FORMATTING_ACTIONS = [
  { value: 'add_table', label: '🔢 Adicionar Tabela' },
  { value: 'structure_list', label: '📝 Estruturar em Lista' },
  { value: 'improve_formatting', label: '🎨 Melhorar Formatação' },
  { value: 'add_subtitles', label: '📑 Adicionar Subtítulos' },
  { value: 'reduce_words', label: '✂️ Reduzir Palavras' },
  { value: 'expand_content', label: '📈 Expandir Conteúdo' },
];

// Quality Check Categories
export const QUALITY_CHECK_CATEGORIES = {
  completeness: { weight: 0.25, label: '📝 Completude' },
  formatting: { weight: 0.25, label: '🎨 Formatação' },
  consistency: { weight: 0.30, label: '🔄 Consistência' },
  compliance: { weight: 0.20, label: '✓ Conformidade' },
};

// Tab Icons
export const TAB_ICONS = {
  documents: 'FileText',
  orientation: 'Compass',
  'concept-map': 'Network',
  roadmap: 'ListChecks',
  elaboration: 'PencilLine',
  'output-form': 'FileCheck',
  history: 'History',
  dashboard: 'BarChart3',
};
